const baseURL = '/api/v1/interior';

export default {
  /**
   * @GET  등록 매장 요약 목록 (최근 수정순, payload 없음) — ?currentPage&listSize
   * @POST 등록 매장 upsert (id 없으면 신규, 있으면 갱신)
   * */
  INTERIOR_STORES: `${baseURL}/stores`,
  /**
   * @param storeId
   * @GET 등록 매장 단건 (payload 포함)
   * @DELETE 등록 매장 삭제 (등록한 담당자만)
   * */
  INTERIOR_STORE_BY_ID: (storeId: string) => `${baseURL}/stores/${storeId}`,
  /**
   * @GET  절감 시뮬레이션 헤더 목록 (최근 수정순, 본문 없음) — 쿼리는 `brand` 뿐이다.
   *       **페이징 파라미터가 없다**(응답 meta 도 null) → 전건이 한 번에 내려온다.
   *       403 = 담당 브랜드가 없는 임직원.
   * @POST 절감 시뮬레이션 **신규 생성**(201). ⚠️ upsert 가 아니다 — 부를 때마다 한 건이
   *       더 쌓인다. 이미 id 가 있는 시뮬을 저장할 땐 반드시 PUT 을 쓸 것(PORTAL-13414).
   *       required: storeId·version·kind·updatedAt / 403 = 담당 브랜드 아닌 매장, 404 = 매장 없음
   * */
  INTERIOR_SIMULATIONS: `${baseURL}/simulations`,
  /**
   * @param storeId 등록 매장 id — 한 매장에 시뮬 **N건**이 달릴 수 있다.
   * @GET 그 매장의 시뮬 헤더 목록 (최근 수정순, 없으면 빈 배열).
   *      403 = 담당 브랜드 아닌 매장 / 404 = 매장 없음
   * */
  INTERIOR_STORE_SIMULATIONS: (storeId: string) =>
    `${baseURL}/stores/${storeId}/simulations`,
  /**
   * @param simulationId **서버 발급 시뮬 id — storeId 가 아니다**(PORTAL-13414).
   * @GET 절감 시뮬레이션 단건(본문 포함). 없는 id 도 404 가 아니라 200 + data=null (실측).
   * @PUT 절감 시뮬레이션 수정. required: version·kind·updatedAt —
   *      **storeId 는 싣지 않는다**(소속 매장 변경 불가).
   *      403 = 담당 브랜드 아님 or 작성자 아님 / 404 = 시뮬 없음
   * @DELETE 절감 시뮬레이션 삭제. 403 = 작성자 아님 / 404 = 시뮬 없음
   * */
  INTERIOR_SIMULATION_BY_ID: (simulationId: string) =>
    `${baseURL}/simulations/${simulationId}`,
  /**
   * 유사매장(비교군 실적) 등록분 — PORTAL-14290. 시드(인덱스 87건) + 정산 품의 완료 자동 등록분.
   * GET ?brand= 목록 · GET /{id} 단건. 등록·수정·삭제는 백엔드 내부/운영용이라 프론트는 읽기만.
   */
  INTERIOR_SIMILAR_PROJECTS: `${baseURL}/similar-projects`,
  INTERIOR_SIMILAR_PROJECT_BY_ID: (id: string) =>
    `${baseURL}/similar-projects/${id}`,
};
